/* template */
<template><div class="mpx-root-view"><es-over-layout :custom-class="(customClass)" :useDefaultNavbar="(false)" :layout="(['header'])" navbarTitle="" :esMainStyle="({background: 'transparent'})" navbarUseRight :useRight="(true)" :leftArrow="(true)" :needScroll="(!isMiniH5)" @onscroll="handleScroll"><div :style="[(headerStyle)] | transRpxStyle" class="home-header" v-if="(!isMiniH5)"><es-navbar :left-arrow="(false)" @click-left="goBack" :onClickLeft="(homeBack)"><div slot="left" :style='["display: flex;"] | transRpxStyle'><es-icon size="25" :style='["display: inline;"] | transRpxStyle' name="angle-left"/></div></es-navbar></div><div class="home-body"><Bg :class="(bannerClass)" :currentProd="(currentProd)"/><Tabs @tabClick="onTabClick" :tabsData="(homeTabs)" class="content"/></div></es-over-layout><es-toast id="es-toast"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m42436e12"}'>
  @import '~@/mixins/stylus/color.styl'

  .home-header
    position fixed
    top 0
    left 0
    z-index 3
  .banner-swiper
    height 240px
    width 100%
    &.mini
      margin-top -40px
  .home-container
    background #f2f6f9
  .home-bg-mini
    background-position-y -40px
  .header
    height 1px
    padding 0 24px
  .content
    margin -78px 0 16px
    position relative
  .to-login-tip
    position fixed
    bottom 48px
    left 0
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m42436e12"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isFirst&isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isFirst&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m42436e12"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-toast':getComponent(require("../../../node_modules/@didi/es-mpx-ui/lib/toast/index.mpx?isComponent&outputPath=components%2Findex68e47551%2Findex")),'Bg':getComponent(require("./components/banner-swiper/index.mpx?isComponent&outputPath=components%2Findex57e2b6a8%2Findex")),'Tabs':getComponent(require("./components/tabs/index.mpx?isComponent&outputPath=components%2Findexe8fca082%2Findex")),'ToLoginTip':getComponent(require("../../components/to-login-tip/index.mpx?isComponent&outputPath=components%2Findex50775d85%2Findex")),'es-over-layout':getComponent(require("../../es-mpx-ui/lib/layout/index.mpx?isComponent&outputPath=components%2Findex2146c876%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
